<template>
  <div class="bg">
      <div class="break el-icon-back"  @click="$router.back()">返回</div>
    <div class="top">
      <!-- 头部 -->
      <div class="purchase-style-header-forever">
        <div class="purchase-style-header-forever-item">
          <div class="purchase-style-header-forever-title">{{ detail.productName + detail.manufacturersName + detail.markName }}</div>
          <div class="purchase-style-header-forever-content">
            <div class="purchase-style-header-forever-conten-price">{{ marketPrice.price || 0 }}</div>
            <div class="purchase-style-header-forever-conten-price-shengjiang">
              <div class="purchase-style-header-forever-conten-price-shengjiang-item">
                <div class="purchase-style-header-forever-conten-price-shengjiang-item-icon" v-if="marketPrice.go_up !== 0">
                  <img :src="marketPrice.go_up < 0 ? '@/assets/update/xaijiang_icon02@2x.png' : '@/assets/update/shangsheng_icon02@2x.png'" />
                </div>
                <div>
                  <div class="purchase-style-header-forever-conten-price-shengjiang-item-value" style="color: #333333;" v-if="marketPrice.go_up == 0">+0</div>
                  <div class="purchase-style-header-forever-conten-price-shengjiang-item-value" style="color: #D13123;" v-else-if="marketPrice.go_up > 0">+{{ marketPrice.go_up }}</div>
                  <div class="purchase-style-header-forever-conten-price-shengjiang-item-value" v-else>{{ marketPrice.go_up }}</div>
                </div>
                <div>
                  <div class="purchase-style-header-forever-conten-price-shengjiang-item-value" style="margin-left: 36px;color: #333333;" v-if="marketPrice.changePercentage == 0">0%</div>
                  <div class="purchase-style-header-forever-conten-price-shengjiang-item-value" style="margin-left: 36px;color: #D13123;" v-else-if="marketPrice.changePercentage > 0">{{ marketPrice.changePercentage }}%</div>
                  <div class="purchase-style-header-forever-conten-price-shengjiang-item-value" style="margin-left: 36px;" v-else>{{ marketPrice.changePercentage }}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 图表 -->
      <div class="purchase-style-content-forever">
        <div class="purchase-style-content-forever-title">折线图</div>
        <!-- 选择头部 -->
        <div class="purchase-style-content-forever-header">
          <div class="purchase-style-content-forever-header-left">
            <div class="purchase-style-content-forever-header-left-item" :class="{'purchase-style-content-forever-header-left-item-active': cellIndex == index}" v-for="(item, index) in navList" :key="index" @click.stop="navClick(index)">{{ item }}</div>
          </div>
          <div style="display: flex;width: 50%; padding-left: 40px; align-self: center;">
            <span style="font-family: Microsoft YaHei; font-weight: bold;font-size: 18px;color: #333333; display: flex; align-self: center; margin-right: 20px;display: flex;flex-shrink: 0;">日期</span>
            <el-date-picker
              style="width: 300px;"
              v-model="timeFw"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期">
            </el-date-picker>
            <el-button style="background: #F42551; color: #FFF; height: 40px; padding: 0 32px; border-radius: 5px; margin-left: 20px;" @click.stop="searchChange">查询</el-button>
          </div>
        </div>
        <!-- echarts图表 -->
         <div  class="echarts-style" style="width:10.7rem;height: 4.5rem;">
          <qiun-vue-ucharts 
          type="area"
          :opts="opts"
          :chartData="chartData"
         />
         </div>
        
        <!-- 历史价格 -->
        <div class="purchase-style-content-forever-title">历史价格</div>
        <div style="width: 100%; height: 500px;">
            <el-table
            :header-cell-style="{fontSize: '15px', backgroundColor: '#EFEFEF',color:'#333'}"
            :data="historyList"
            height="450"
            ref="myTable"
            v-el-table-infinite-scroll="historyValue"
            style="width: 100%; margin-top: 30px; margin-bottom: 40px; overflow: auto;">
            <el-table-column
              fixed
              label="日期">
              <template slot-scope="scope">
                <span v-if="scope.row" style="font-size: 16px;color: #333333;">{{ scope.row.priceTime.split(' ')[0] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              label="价格">
              <template slot-scope="scope">
                <span style="font-family: Microsoft YaHei;font-size: 17px;color: #333333;" v-if="scope.row && scope.row.go_up == 0">{{ scope.row.price }}</span>
                <span style="font-family: Microsoft YaHei;font-size: 17px;color: #D13123;" v-if="scope.row && scope.row.go_up > 0">{{ scope.row.price }}</span>
                <span style="font-family: Microsoft YaHei;font-size: 17px;color: #48AF92;" v-if="scope.row && scope.row.go_up < 0">{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              label="涨跌">
              <template slot-scope="scope">
                <span style="font-family: Microsoft YaHei;font-size: 17px;color: #333333;" v-if="scope.row && scope.row.go_up == 0">{{ scope.row.go_up }}</span>
                <span style="font-family: Microsoft YaHei;font-size: 17px;color: #D13123;" v-if="scope.row && scope.row.go_up > 0">{{ scope.row.go_up }}</span>
                <span style="font-family: Microsoft YaHei;font-size: 17px;color: #48AF92;" v-if="scope.row && scope.row.go_up < 0">{{ scope.row.go_up }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qiunVueUcharts from '@qiun/vue-ucharts'
export default {
  components: {
    qiunVueUcharts
  },
  data() {
    return {
      timeFw:[],
      priceTime: "",
      priceTimeEnd:"",
      selTime: "WEEK",
      navList: ["周线", "月线", "季线"],
      option: {},
      ids: "",
      aptitudeData: [],
      myChart: null,
      detail: "",
      marketPrice: "",
      historyList: [],
      pageNo: 0,
      cellIndex: 0,
      chartData: {},
	opts: {
      color: ["#1890FF","#91CB74","#FAC858","#EE6666","#73C0DE","#3CA272","#FC8452","#9A60B4","#ea7ccc"],
      padding: [30,30,10,30],
      enableScroll: false,
      legend: {},
			dataLabel:false,
			dataPointShape:false,
      xAxis: {
          disableGrid: true,	 
          labelCount:3,				
          disabled:false,
           gridType: "dash"
      },
			yAxis:{}
      
    },
    extra: {
			type: "step",
			width: 1,
			activeType: "none"
		}        
   }
  },
  async mounted() {
  },
  created() {
    this.pageNo=0
    this.historyList=[]
    let date = new Date().getFullYear()
    + "-" + ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : ("0" + (new Date().getMonth() + 1))) 
    + "-" +  (new Date().getDate() > 9 ? new Date().getDate() : ("0" + new Date().getDate()))
    this.priceTime = date
    setTimeout(()=> {
      if (this.$route.query.id) {
        this.ids = this.$route.query.id
        this.lineChartDetail()
        this.initChang()
        this.history()
      }
    }, 500)
  },
  watch: {
    "$route.name": {
      handler(newName) {
        if (newName === "purchase_hangqing_detail") {
          let date = new Date().getFullYear()
          + "-" + ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : ("0" + (new Date().getMonth() + 1))) 
          + "-" +  (new Date().getDate() > 9 ? new Date().getDate() : ("0" + new Date().getDate()))
          this.priceTime = date
          setTimeout(()=> {
            if (this.$route.query.id) {
              this.pageNo=0
              this.historyList=[]
              this.ids = this.$route.query.id
              this.lineChartDetail()
              this.initChang()
              this.history()
            }
          }, 500)
        }
      }
    }
  },
  methods: {
    historyValue() {
      this.pageNo+=1
      console.log("页码",this.pageNo)
      //this.history()
      let data = {'pageNo': this.pageNo, 'pageSize': 10, 'rawMaterialPricesId': this.ids}
				this.$apiFun.history(data).then(res => {
          this.historyList = this.historyList.concat(res.result.rows)
        })
    },
    // 获取历史价格
    history(){
				let data = {'pageNo': this.pageNo, 'pageSize': 10, 'rawMaterialPricesId': this.ids}
				this.$apiFun.history(data).then(res => {
              this.historyList = res.result.rows
        })
			},
    initChang() {
      // 基于准备好的dom，初始化echarts实例
      // this.myChart = echarts.init(document.getElementById('main'));
      // // let options = dataOptions()
      // this.option = dataOptions()
      // this.option.series = [{
			// 	data: [],
			// 	type: 'line',
			// 	lineStyle: { color: '#3756DF' },
			// 	itemStyle: { color: '#3756DF' },
			// 	smooth: true,
			// 	areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(67, 106, 218, 0.2)'}, {offset: 1, color: 'rgba(69, 107, 220, 0)' }])
			// 	}
			// }]
      this.lineChart(this.ids, this.selTime);
     
    },
    lineChartDetail(){
				this.$apiFun.lineChartDetail(this.ids).then(res => {
					this.detail = res.result
					this.marketPrice = res.result.marketPrice
          this.$forceUpdate()
				})
			},
    // 折线图
		lineChart(id,time){
      this.$apiFun.lineChart({rawMaterialPricesId: id, type: time, priceTime: this.priceTime,priceTimeEnd:this.priceTimeEnd}).then(res => {
        this.aptitudeData = res.result
        this.chartData={}
        var dataCharts = {
					categories:[],
					series:[{name:"价格",data:[]}],
					};  
        res.result.forEach(item => {
          if (item) {							
           // if (item.priceTime) {
             // this.option.xAxis.data.push(item.priceTime.split(" ")[0])
            //}
            // this.option.xAxis.data.reverse()
           // this.option.series[0].data.push(item.price)
            // this.option.series[0].data.reverse()
            dataCharts.categories.push(item.priceTime.split(" ")[0])
						dataCharts.series[0].data.push(item.price)
          }
        })
        // 绘制图表
       // this.myChart.setOption(JSON.parse(JSON.stringify(dataCharts)));
        this.chartData = JSON.parse(JSON.stringify(dataCharts));
      })
		},
    navClick(index) {
				this.cellIndex = index
				let timeData = ["WEEK","MONTH","SEASON"]
				this.selTime = timeData[index]
				// this.option.xAxis.data = []
				// this.option.series[0].data = []
				this.initChang()
		},
    searchChange() {
     
      if(this.timeFw.length<2){
        this.$message({
                type: "error",
                message: "请选择时间段!",
                duration: 1500,
              });
      }else{
        console.log("--------------",this.timeFw[0]);
        this.priceTime  = this.timeFw[0]
         this.priceTimeEnd  = this.timeFw[1]
    
         this.selTime="DAY"
        this.initChang()
      }
    
      // this.option.xAxis.data = []
			// this.option.series[0].data = []
    }
  },
}
</script>

<style lang="less" scoped>

.bg {
  background: #ffffff;
  box-shadow: 0px 3px 20px 0px rgba(230, 230, 230, 0.8);
  border-radius: 10px;
  text-align: left;
  font-family: Microsoft YaHei;
  .break{
padding: 0.2rem 0.2rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 16px;
cursor:pointer;
      display: flex;
    }
  // 顶部标题
  .top {

  }
  //返回

  .purchase-style-header-forever {
    width: 95%;
    height: 120px;
    position: relative;
    background: url("../../assets/update/hangqingshuju_bg@2x.png");
    background-size: 100% 120px;
    border-radius: 0;
    display: flex;
    flex-direction: column;
	left: 0.26rem;
    .purchase-style-header-forever-item {
      width: calc(100% - 56px);
      height: calc(120px - 40px);
      padding: 20px 24px;
      display: flex;
      flex-direction: column;
      .purchase-style-header-forever-title {
        width: auto;
        height: auto;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 20px;
        color: #FFFFFF;
      }
      .purchase-style-header-forever-content {
        width: auto;
        height: auto;
        display: flex;
        align-self: center;
        flex-direction: column;
        .purchase-style-header-forever-conten-price {
          width: 200px;
          height: auto;
          font-family: 'Impact';
          font-weight: 400;
          font-size: 32px;
          color: #FFFFFF;
          text-align: center;
        }
        .purchase-style-header-forever-conten-price-shengjiang {
          width: auto; height: auto;
          display: flex;
        }
        .purchase-style-header-forever-conten-price-shengjiang-item {
          width: auto; height: auto;
          display: flex;
          margin: auto;
          margin-top: 4px;
          .purchase-style-header-forever-conten-price-shengjiang-item-icon {
            width: 13px;
            height: 23px;
            display: flex;
            align-self: center;
          }
          .purchase-style-header-forever-conten-price-shengjiang-item-icon img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .purchase-style-header-forever-conten-price-shengjiang-item-value {
            width: auto;
            height: auto;
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 16px;
            color: #9CE403;
            display: flex;
            align-self: center;
            margin-left: 7px;
          }
        }
      }
    }
  }
  .purchase-style-content-forever {
    width: calc(100% - 60px);
    height: auto;
    display: flex;
    margin: 0 30px;
    flex-direction: column;
    .purchase-style-content-forever-title {
      width: auto;
      height: auto;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      margin-top: 30px;
    }
    .purchase-style-content-forever-header {
      width: 100%;
      height: auto;
      display: flex;
      margin-top: 30px;
    }
    .purchase-style-content-forever-header-left {
      width: 50%;
      height: auto;
      display: flex;
    }
    .purchase-style-content-forever-header-left-item {
      width: 80px;
      height: 36px;
      background: #EBEBEB;
      border-radius: 10px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #8C8989;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      cursor: pointer;
    }
  }
    .echarts-style {
    margin-top: 40px;
  }
}
::v-deep .el-input__prefix {
  width: 25px;//这里要给宽度的，要不然会挡住事件，触发不了选择日期
  position: absolute;
  left: 90%!important;
}
::v-deep .el-icon-date {
  background: url(../../assets/update/time_icon@2x.png) center center no-repeat;
  background-size: 20px;
}
::v-deep .el-input__prefix .el-input__icon {
  width: 100%;
}
::v-deep .el-icon-date:before {
  content: "";
}
::v-deep .el-input--prefix .el-input__inner {
  padding-left: 15px;
}
@font-face {
	font-family: 'Impact';
	src: url('../../assets/styles/IMPACT.TTF');
	font-weight: normal;
	font-style: normal;
}
::v-deep .el-table .cell {
  text-align: center;
}
::v-deep .news_classify .el-select {
  margin: 0;
}
.text-value {
  width: auto;
  height: auto;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  margin: auto;
}
.purchase-style-content-forever-header-left-item-active {
  background: #DFE7FC!important;
  color: #1929EC!important;
}
</style>